import { uniqBy } from 'lodash';

import { FlexMatchSetting } from './types';
import { SelfMatchAction } from 'components/types';

import { SelfMatchAction as SelfMatchActionEnum } from 'components/enums';

export const getFlexMatchSettingAction = ({
  requests,
  employeeCostCenterType,
  costCenterId
}: FlexMatchSetting): SelfMatchAction | null => {
  const settings = requests.map((r) => r.employeeCostCenterActions).flat();
  const foundSettings = settings.filter(
    (a) =>
      a.employeeCostCenterType === employeeCostCenterType &&
      (costCenterId ? a.costCenterId === costCenterId : true)
  );

  if (requests.length > 1) {
    if (!foundSettings.length) {
      return SelfMatchActionEnum.NONE;
    }
    if (foundSettings.length !== requests.length) {
      return null;
    }
    if (uniqBy(foundSettings, 'action').length > 1) {
      return null;
    }
  } else if (!foundSettings.length) {
    return SelfMatchActionEnum.NONE;
  }

  return foundSettings[0].action;
};
